var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4114 3.45129C17.2424 2.17422 16.1365 1.188 14.8037 1.188H3.43079C1.98218 1.188 0.8 2.35329 0.8 3.79086V14.9083C0.8 16.3459 1.98218 17.5112 3.43079 17.5112H16.5694C18.018 17.5112 19.2001 16.3459 19.2001 14.9083V5.91663C19.2001 4.77083 18.4487 3.799 17.4114 3.45129ZM3.43079 2.7105H14.8037C15.2347 2.7105 15.6072 2.95737 15.7859 3.31381H3.43079C3.05208 3.31381 2.69181 3.39375 2.36613 3.53711C2.48204 3.06476 2.914 2.7105 3.43079 2.7105ZM16.5693 15.9887H3.43079C2.82487 15.9887 2.33555 15.5017 2.33555 14.9083V5.91663C2.33555 5.32328 2.82487 4.83628 3.43079 4.83628H16.5694C17.1753 4.83628 17.6646 5.32328 17.6646 5.91663V7.67533H14.2441C12.7011 7.67533 11.4422 8.91653 11.4422 10.4474C11.4422 11.9782 12.7012 13.2194 14.2441 13.2194H17.6646V14.9083C17.6646 15.5017 17.1752 15.9887 16.5693 15.9887ZM17.6646 11.6969H14.2441C13.5438 11.6969 12.9777 11.134 12.9777 10.4474C12.9777 9.76071 13.5438 9.19783 14.2441 9.19783H17.6646V11.6969Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1bea0fd517d6d310e337d04f210f26a3.svg";
export { ForwardRef as ReactComponent };